import React from 'react'
import { Select } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { BEE_FONTS } from 'Constants/beeEditor'

const FontFamilySelect = ({ value, onChange, disabled }) => {
  const fontFamilyOptions = BEE_FONTS.map(m => ({
    label: m.name,
    value: m.fontFamily
  }))
  fontFamilyOptions.unshift({
    label: 'inherit',
    value: 'inherit'
  })

  return (
    <Select
      options={fontFamilyOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default FontFamilySelect

FontFamilySelect.propTypes = {
  value: PropTypes.num,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
